import store from '@/store'

function isTenant() {
  return store.getters.user.type === 'corp'
}
export default {
  inserted(el, binding, vNode) {
    if (isTenant()) {
      el.style.display = 'none'
    }
  },
  update(el, binding, vNode) {
    if (isTenant()) {
      el.style.display = 'none'
    }
  }
}
